var exports = {
  "kL": "x936d19a0--e6d868--container",
  "n1": "x936d19a0--e6d868--circle",
  "AI": "x936d19a0--e6d868--checkmark",
};

module.exports = exports;
